import { InvoiceSummary } from 'src/services/interfaces/billing.interface';

export const downloadBillingHistoryAsCSV = (invoices: InvoiceSummary[]) => {
  if (!invoices || invoices.length === 0) {
    alert('No billing history available to download');
    return;
  }

  // CSV headers
  const headers = [
    'Invoice ID',
    'Created Date',
    'Status',
    'Amount Due',
    'Amount Paid',
    'Currency',
    'Period Start',
    'Period End',
    'URL'
  ];

  // Convert invoices to CSV rows
  const csvRows = invoices.map(invoice => [
    invoice.id,
    new Date(invoice.createdAt).toLocaleDateString(),
    invoice.status,
    invoice.amountDue.toString(),
    invoice.amountPaid.toString(),
    invoice.currency,
    new Date(invoice.periodStart).toLocaleDateString(),
    new Date(invoice.periodEnd).toLocaleDateString(),
    invoice.url || ''
  ]);

  // Combine headers and rows
  const csvContent = [headers, ...csvRows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `billing-history-${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
